import { arrayOf, objectOf } from "@altostra/type-validations";
import { boolean, string } from "@altostra/type-validations/lib/primitives";

const isOauthPartnerPolicy = objectOf({
  integration_partner: string,
  all_app_groups: boolean,
  app_group_ids: arrayOf(string),
});

export const isGetCompaniesCompanyIdOauthMcpSettingsPartnerPoliciesResult = objectOf({
  partner_apps_enabled: boolean,
  partner_policies: arrayOf(isOauthPartnerPolicy),
});
